<template>
    <div class="v-schedule__calendar calendar" :class="{'v-schedule_patients-yes': access === 'doctor'}" v-if="((appointmentsClinicFreeCount > 0 || appointmentsOnlineFreeCount > 0) && windowWidth <= 767) || windowWidth > 767">
        <div class="calendar__body">
            <calendar-controls></calendar-controls>
            <calendar-mobile v-if="windowWidth <= 767"></calendar-mobile>
            <calendar-desktop v-else></calendar-desktop>
        </div>
    </div>
</template>

<script>
	import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

	import dayjs from 'dayjs';
	import utc from 'dayjs/plugin/utc';
	import customParseFormat from 'dayjs/plugin/customParseFormat';

	import CalendarControls from "./CalendarControls.vue";
	import CalendarDesktop from "./desktop/CalendarDesktop.vue";
	import CalendarMobile from "./mobile/CalendarMobile.vue";

	dayjs.extend(customParseFormat);
	dayjs.extend(utc);

    export default {
		name: 'Calendar',
		components: {
			CalendarControls,
			CalendarMobile,
			CalendarDesktop,
        },
        data: () => ({
            yourUtcOffset: dayjs().format('Z'),
        }),
        computed: {
			...mapState([
				'startDate',
				'activeTimePeriod',
                'access',
                'windowWidth',
                'firstAppointmentPeriod',
                'appointmentsClinicFreeCount',
                'appointmentsOnlineFreeCount'
			]),
			...mapGetters([
				'timePeriods',
			]),
        },
        watch: {
			startDate: {
				handler: function () {
					this.generateCells();
                },
			},
			activeTimePeriod: {
				handler: function () {
					this.generateCells();
                },
			},
            windowWidth: {
                handler: function (afterWidth, beforeWidth) {
                    if (afterWidth <= 767 && (!beforeWidth || (beforeWidth > 767))) {
                        this.setActiveTimePeriod(this.timePeriods[this.timePeriods.length - 1]);
                    }
                    if (afterWidth > 767 && (!beforeWidth || (beforeWidth <= 767))) {
                        this.setActiveTimePeriod(this.firstAppointmentPeriod);
                    }
                },
            immediate: true,
        },

    },
        methods: {
			...mapActions([
				'generateCells',
                'getFirstAppointmentPeriod'
			]),
			...mapMutations([
				'setWindowWidth',
				'setActiveTimePeriod',
			]),
        },
		created() {
			window.addEventListener('resize', this.setWindowWidth);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.setWindowWidth);
		},
    }
</script>


